import { render, staticRenderFns } from "./home-vr.vue?vue&type=template&id=62f0dd5a&scoped=true&"
import script from "./home-vr.vue?vue&type=script&lang=js&"
export * from "./home-vr.vue?vue&type=script&lang=js&"
import style0 from "./home-vr.vue?vue&type=style&index=0&id=62f0dd5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f0dd5a",
  null
  
)

export default component.exports